const tabs = [
  {
    id: 'top',
    name: 'トップ'
  },
  {
    id: 'promotion-request',
    name: '登録'
  },
  {
    id: 'promotion-info',
    name: '広告費明細'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/promotion-tabs.js